module.exports = __webpack_public_path__ + "static/img/qx_code.eb016667.jpg";